export function getItemRoot(el: HTMLElement): HTMLElement {
  const root = el?.closest('[data-element-id]');
  if (!root) throw new Error('Item root not found');
  return root as HTMLElement;
}

export function getScrollAncestor(el: HTMLElement): HTMLElement {
  let node: HTMLElement | null = el;

  while (node) {
    const { overflowY } = getComputedStyle(node);
    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentElement;
  }

  return document.scrollingElement as HTMLElement;
}

export function smoothFocusItem<T extends HTMLElement>(textarea: T) {
  const item = getItemRoot(textarea);
  const scroller = getScrollAncestor(item);

  textarea.focus({ preventScroll: true });

  requestAnimationFrame(() => {
    const itemRect = item.getBoundingClientRect();
    const scrollerRect = scroller.getBoundingClientRect();

    scroller.scrollTo({
      top: itemRect.top - scrollerRect.top + scroller.scrollTop - 12,
      behavior: 'smooth',
    });
  });
}
